import { Component, Prop, Watch } from 'vue-property-decorator';
import { SidebarMenu } from 'vue-sidebar-menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import store from '@app/store';
import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';
import { Route } from 'vue-router';
import { CenterSetting } from '@core/interfaces/center-setting';
import { mixins } from 'vue-class-component';
import CenterSidebarEntriesMixin from '@shared/layouts/components/sidebar/sidebar-entries/center-sidebar-entries-mixin';
import ClubSidebarEntriesMixin from '@shared/layouts/components/sidebar/sidebar-entries/club-sidebar-entries-mixin';
import LeagueSidebarEntriesMixin from '@shared/layouts/components/sidebar/sidebar-entries/league-sidebar-entries-mixin';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
@Component({
  name: 'bpc-sidebar',
  components: {
    SidebarMenu,
    VuePerfectScrollbar,
  },
})
export default class Sidebar extends mixins(
  CenterSidebarEntriesMixin,
  ClubSidebarEntriesMixin,
  LeagueSidebarEntriesMixin,
) {
  public showHiddenMenuItems: boolean = store.getters['auth/showHiddenMenuItems'];
  public isOpen: boolean = false;
  public sidebarActive: boolean = false;
  public menuTab: string = 'main';
  public tabs = ['main'];
  public menuMain = [];

  public get showMainMenuTab(): boolean {
    return (
      this.$authorizationService.hasPermissions([
        this.getAuthorizationHelper().fixedPermissions.sections.main,
      ]) && this.tabs.includes('main')
    );
  }

  public get showCommunicationMenuTab(): boolean {
    return (
      this.$authorizationService.hasPermissions([
        this.getAuthorizationHelper().fixedPermissions.sections.communication,
      ]) &&
      (this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME) ||
        this.$modulesService.hasModuleActivated(ModulesHelper.CMS_MODULE_NAME)) &&
      this.tabs.includes('communication')
    );
  }
  public get showConfigurationMenuTab(): boolean {
    return (
      this.$authorizationService.hasPermissions([
        this.getAuthorizationHelper().fixedPermissions.sections.configuration,
      ]) && this.tabs.includes('configuration')
    );
  }

  public get showMenuTabs(): boolean {
    const arr = [
      this.showMainMenuTab,
      this.showCommunicationMenuTab,
      this.showConfigurationMenuTab,
    ];
    const numOfItems = arr.filter(item => item).length;
    return numOfItems > 1;
  }

  public get filteredMenuMain() {
    return this.menuMain.filter(item => {
      return (
        !item.hidden &&
        (item.module
          ? this.$modulesService.hasModuleActivated(item.module)
          : item.modules
          ? this.$modulesService.hasSomeModuleActivated(item.modules)
          : true) &&
        (item.permissions ? this.$authorizationService.hasPermissions(item.permissions) : true)
      );
    });
  }

  public menuCommunication = [];
  public get filteredMenuCommunication() {
    return this.menuCommunication.filter(item => {
      return (
        !item.hidden &&
        (item.module
          ? this.$modulesService.hasModuleActivated(item.module)
          : item.modules
          ? this.$modulesService.hasSomeModuleActivated(item.modules)
          : true) &&
        (item.permissions ? this.$authorizationService.hasPermissions(item.permissions) : true)
      );
    });
  }

  public menuConfiguration = [];
  public get filteredMenuConfiguration() {
    return this.menuConfiguration.filter(item => {
      return (
        !item.hidden &&
        (item.module
          ? this.$modulesService.hasModuleActivated(item.module)
          : item.modules
          ? this.$modulesService.hasSomeModuleActivated(item.modules)
          : true) &&
        (item.permissions ? this.$authorizationService.hasPermissions(item.permissions) : true)
      );
    });
  }

  public collapsed: boolean = true;

  public windowWidth: number = 0;

  public get hideMenuItem(): boolean {
    // TODO_CLUBROLE review this when we change the way it works by permission
    return !this.showHiddenMenuItems || !this.$store.getters['auth/isSuperAdmin'];
  }

  get tenantType() {
    // console.log(this.$store.getters['centerSettings/centerSettings']);
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].center_type
      : null;
  }

  public get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get hideTrueCostSidebar() {
    return !(this.centerSetting?.subvention_mode === 'true_cost');
  }

  get hideAnalyticsSidebar() {
    return !this.centerSetting?.analytics_usage;
  }

  get hideSepaSidebar() {
    return !this.centerSetting?.activate_sepa_direct_debit;
  }

  get hideAccessPointsSidebar(): boolean {
    return this.accessControlConfig?.access_control_service !== 'internal';
  }
  get hideTppwbSideBar(): boolean {
    return (
      !this.centerSetting?.tppwb_sync_padel_activated &&
      !this.centerSetting?.tppwb_sync_tennis_activated
    );
  }

  @Prop(String) readonly sidebarbg: string;

  /* Lifecycle hooks */
  // created () { }
  // updated () { }

  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);

      // Init
      this.getWindowWidth();

      switch (this.tenantType) {
        case 'center':
          this.tabs = this.centerMenuEntriesTabs;
          this.menuMain = this.centerMainMenuEntries;
          this.menuCommunication = this.centerCommunicationMenuEntries;
          this.menuConfiguration = this.centerConfigurationMenuEntries;
          break;
        case 'club':
          this.tabs = this.clubMenuEntriesTabs;
          this.menuMain = this.clubMainMenuEntries;
          this.menuCommunication = this.clubCommunicationMenuEntries;
          this.menuConfiguration = this.clubConfigurationMenuEntries;
          break;
        case 'league':
          this.tabs = this.leagueMenuEntriesTabs;
          this.menuMain = this.leagueMainMenuEntries;
          break;
        default:
          this.tabs = ['main'];
          this.menuMain = [];
      }
    });
    this.tabs.forEach(tab => {
      if (this.$route.fullPath.indexOf(tab) > -1) {
        this.menuTab = tab;
      }
    });
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }

  toggleBodyClass(className) {
    const el = document.body;
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }
  toggleSidebarHover(add, className) {
    const el = document.body;
    this.sidebarActive = !this.sidebarActive;

    this.windowWidth = document.documentElement.clientWidth;

    if (this.windowWidth > 992) {
      if (add === 'add') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  }
  getWindowWidth() {
    const el = document.body;

    this.windowWidth = document.documentElement.clientWidth;

    if (this.windowWidth < 1350) {
      el.classList.add('closed-sidebar', 'closed-sidebar-md');
    } else {
      el.classList.remove('closed-sidebar', 'closed-sidebar-md');
    }
  }
  changeMenuTabTo(tab) {
    this.menuTab = tab;
    // if (this.menuTab === 'main') {
    //   console.log(this.menuMain);
    // }
    // if (this.menuTab === 'communication') {
    //   console.log(this.menuCommunication);
    // }
    // if (this.menuTab === 'configuration') {
    //   console.log(this.menuConfiguration);
    // }
  }

  getAuthorizationHelper() {
    return AuthorizationHelper;
  }

  getModulesHelper() {
    return ModulesHelper;
  }

  onItemClick() {
    if (this.$store.getters['pos/showDrawer'] && !this.$store.getters['pos/posInSidepane']) {
      this.$store.commit('pos/closeDrawer');
    }
  }

  oldRoute: Route;
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(newRoute: Route) {
    // Remove class only if the main URL path changes (to close the extended filters)
    if (!this.oldRoute || newRoute.path != this.oldRoute.path) {
      document.body.classList.remove('extended-filters-opened');
      this.oldRoute = newRoute;
    }
  }
}
